const customSignStyles = ['original', 'business', 'portraits', 'garden', 'hangers', 'standing', 'lettering', 'memorials'];
function initializeCustomCollections() {
  const current = new URL(window.location.href);
  const collection = current.searchParams.get('custom_collection');
  if (['custom-signs-metal-art', 'custom-metal-trophies-awards', 'custom-hitch-covers'].includes(collection)) {
    document.querySelectorAll('[data-emcs-return]').forEach(link => {
      const url = new URL(link.href);
      const tag = current.searchParams.get('custom_theme');
      const style = current.searchParams.get('custom_style') || (current.searchParams.get('custom_view') === 'business' ? 'business' : '');
      url.pathname = '/collections/' + collection + (tag && /^[a-z0-9-]+$/.test(tag) ? '/' + tag : '');
      url.search = '';
      if (collection === 'custom-signs-metal-art' && customSignStyles.includes(style)) url.searchParams.set('custom_style', style);
      if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
      url.hash = 'em-collection-products';
      link.href = url.toString();
    });
  }
  const section = document.querySelector('.em-native-custom');
  if (!section) return;
  const grid = section.querySelector('.product-list--collection');
  if (!grid) return;
  const themeNames = current.searchParams.getAll('filter.p.tag');
  const reset = section.querySelector('[data-em-custom-reset]');
  if (reset && themeNames.length) reset.hidden = false;
  if (themeNames.length) {
    const themeStatus = section.querySelector('[data-em-sign-browser] .em-theme-status');
    if (themeStatus) {
      themeStatus.classList.add('is-filtered');
      themeStatus.querySelector('.em-theme-status__text').textContent = section.dataset.emViewing + ' ' + section.querySelector('h1').textContent.trim() + ' · ' + themeNames.join(', ');
      themeStatus.querySelector('[data-em-style-clear]').hidden = false;
      section.querySelector('[data-em-sign-browser]').classList.add('has-selection');
    }
    grid.querySelectorAll('.em-project-card').forEach(card => {
      const tags = JSON.parse(card.dataset.projectTags || '[]');
      card.hidden = !themeNames.every(tag => tags.includes(tag));
      card.querySelectorAll('a').forEach(link => {
        const url = new URL(link.href);
        url.searchParams.set('custom_theme', themeNames[0].toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));
        link.href = url.toString();
      });
    });
    section.querySelectorAll('.em-universe--sort a').forEach(link => {
      const url = new URL(link.href);
      url.searchParams.delete('filter.p.tag');
      themeNames.forEach(tag => url.searchParams.append('filter.p.tag', tag));
      link.href = url.toString();
    });
  }
  const sort = current.searchParams.get('sort_by');
  if (['title-ascending', 'title-descending'].includes(sort)) {
    const direction = sort === 'title-ascending' ? 1 : -1;
    [...grid.querySelectorAll('.em-project-card')].sort((a, b) => direction * a.querySelector('h2').textContent.trim().localeCompare(b.querySelector('h2').textContent.trim())).forEach(card => grid.appendChild(card));
  }
  const style = current.searchParams.get('custom_style') || (section.dataset.legacyBusiness === 'true' ? 'business' : '');
  const visibleTotal = grid.querySelectorAll('.em-project-card:not([hidden])').length;
  const totalLabel = section.querySelector('.collection__products-count-total');
  if (totalLabel) totalLabel.textContent = `${visibleTotal} ${visibleTotal === 1 ? section.dataset.galleryOne : section.dataset.galleryOther}`;
  if (section.dataset.customCollection !== 'custom-signs-metal-art' || !customSignStyles.includes(style)) return;
  const choice = section.querySelector(`[data-em-custom-style-label="${style}"]`);
  if (!choice) return;
  const related = section.querySelector('[data-em-business-related]');
  if (related) related.hidden = style !== 'business';
  let visible = 0;
  grid.querySelectorAll('.em-project-card').forEach(card => {
    const tags = JSON.parse(card.dataset.projectTags || '[]');
    card.hidden = card.dataset.signStyle !== style || !themeNames.every(tag => tags.includes(tag));
    if (card.hidden) return;
    visible += 1;
    card.querySelectorAll('a').forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('custom_style', style);
      link.href = url.toString();
    });
  });
  const status = section.querySelector('[data-em-sign-browser] .em-theme-status');
  if (status) {
    status.classList.add('is-filtered');
    status.querySelector('.em-theme-status__text').textContent = section.dataset.emViewing + ' ' + section.querySelector('h1').textContent.trim() + ' · ' + choice.textContent.trim();
    status.querySelector('[data-em-style-clear]').hidden = false;
    section.querySelector('[data-em-sign-browser]').classList.add('has-selection');
  }
  if (reset) reset.hidden = false;
  const count = section.querySelector('.collection__products-count-total');
  if (count) count.textContent = `${visible} ${visible === 1 ? section.dataset.galleryOne : section.dataset.galleryOther}`;
  section.querySelectorAll('.em-universe--sort a').forEach(link => {
    const url = new URL(link.href);
    url.searchParams.set('custom_style', style);
    link.href = url.toString();
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeCustomCollections);
else initializeCustomCollections();
document.addEventListener('shopify:section:load', initializeCustomCollections);
window.addEventListener('pageshow', initializeCustomCollections);
